import React, { useState } from 'react'
import LinkRoleToOperationForm from './form'
import LinkRoleToOperationTable from './table'
import { Grid, Typography, Button } from '@material-ui/core'
import { postToApi } from 'actions'
import { useStateValue } from 'context/store'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { useStyles } from './styles'

const INITIAL_SELECTED_OPTIONS = {
   role: { id: '', name: '' },
   applications: [],
   modules: [],
   functionalities: [],
   operations: []
}

const LinkRoleToOperation = () => {
   const classes = useStyles()

   const [selectedOptions, setSelectedOptions] = useState(
      INITIAL_SELECTED_OPTIONS
   )
   const [tableData, setTableData] = useState([])

   const [{ sessionUser }] = useStateValue()
   const user = sessionUser?.settings

   function createTableData(selectedOptions) {
      const rows = []
      const { role, applications, modules, functionalities, operations } =
         selectedOptions
      if (operations.length) {
         const firstRow = {
            id: role.id,
            role: role.name,
            application: applications[0].name,
            module: modules[0].name,
            functionality: functionalities[0].name,
            operation: operations[0].name,
            createdDate: new Date(Date.now()).toLocaleDateString(),
            createdBy: user.email
         }
         rows.push(firstRow)
         const maxRows = Math.max(
            applications.length,
            modules.length,
            functionalities.length,
            operations.length
         )
         for (let index = 1; index < maxRows; index++) {
            const row = { id: role.id, parentId: role.id }
            if (applications[index]?.name) {
               row.application = applications[index].name
            }
            if (modules[index]?.name) {
               row.module = modules[index].name
            }
            if (functionalities[index]?.name) {
               row.functionality = functionalities[index].name
            }
            if (operations[index]?.name) {
               row.operation = operations[index].name
            }
            rows.push(row)
         }
      }
      return rows
   }

   async function _linkRoleToOperation() {
      const { role, operations } = selectedOptions
      const url = `${process.env.REACT_APP_ROLES_API}/roles/${role.id}/operations`
      const payload = {
         operationsId: operations.map(operation => operation.id)
      }
      await postToApi(url, payload)
      const rows = createTableData(selectedOptions)
      setTableData(rows)
   }
   const linkRoleToOperation = useApiRequest(
      _linkRoleToOperation,
      'Rol a operación: Registrar'
   )

   function linkOtherRol() {
      setSelectedOptions(INITIAL_SELECTED_OPTIONS)
      setTableData([])
   }

   const isTableEmpty = !tableData.length

   return (
      <Grid className={classes.linkRoleToOperationContainer}>
         <Grid className={classes.namebar}>
            <Typography className={classes.title}>
               Relacionar Rol a Operación
            </Typography>
            <div className={classes.line} />
         </Grid>
         <Grid className={classes.content}>
            {isTableEmpty && (
               <LinkRoleToOperationForm
                  selectedOpts={[
                     selectedOptions,
                     setSelectedOptions,
                     INITIAL_SELECTED_OPTIONS
                  ]}
                  linkRoleToOperation={linkRoleToOperation}
               />
            )}
            {!isTableEmpty && (
               <>
                  <LinkRoleToOperationTable tableData={tableData} />
                  <Grid className={classes.buttonsContainer}>
                     <Button
                        onClick={linkOtherRol}
                        variant="contained"
                        className={classes.button}
                        color="primary"
                     >
                        RELACIONAR OTRO ROL
                     </Button>
                  </Grid>
               </>
            )}
         </Grid>
      </Grid>
   )
}

export default LinkRoleToOperation
